function ApplyContainerMinHeight() {
    const headerHeight = $('#tryb-header').outerHeight();
    const footerHeight = $('#tryb-footer').outerHeight();
    const totalHeight = headerHeight + footerHeight;
    $('.container-auto-height').css('min-height', 'calc(100vh - ' + totalHeight + 'px)');
}

function ApplyCartPosition(cartId: string, containerId: string) {
    var lgBreakpoint = 1024;

    var isMobile = document.documentElement.offsetWidth < lgBreakpoint;
    var containerTopPadding = $(containerId).css('padding-top');
    var containerPadding = 0;

    if (containerTopPadding && containerTopPadding.indexOf('px') >= 0) {
        containerPadding = parseInt($(containerId).css('padding-top').replace(/[^-\d\.]/g, ''));
    }

    if (!isMobile) {
        var isEoCarouselVisible = $('#carousel-header').length > 0;
        var headerHeight = $('#tryb-header').outerHeight();
        var totalTopDistance = containerPadding + headerHeight;
        var scrollPosition = $(window).scrollTop();
        if (scrollPosition > totalTopDistance && !isMobile && !isEoCarouselVisible) {
            var cartTopPosition = scrollPosition - totalTopDistance - 20;
            $(cartId).css('top', cartTopPosition);
        } else {
            $(cartId).css('top', 0);
        }
    } else {
        $(cartId).css('top', 0);
    }
}

const UiService = { ApplyCartPosition, ApplyContainerMinHeight };

export default UiService;